let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2YOAJ")).then(() => parcelRequire('cR5uE'));